import { i as inIframe } from './auth-9c4dee7d.js';
export { A as Auth, a as AuthConfigTemplate } from './auth-9c4dee7d.js';
import './tslib.es6-61a17366.js';

/**
 * The view object represents the current active view.
 * A common use is to figure out the QID of the active view, E.g:
 * ```js
 * let viewId = View.getId()
 * ```
 */
class View {
  /**
   * Get view id for current twintag
   * @returns string view id
   */
  static getId() {
    let sp = window.location.pathname.split('/');
    return sp && sp.length > 0 ? (inIframe() ? sp[sp.indexOf('views') + 1] : sp[sp.length - 1]) : '';
  }
}

export { View };
